import { Pipe, PipeTransform } from '@angular/core';
import { displayCaptureStatusReason } from '../../core/options/capture-status-reason.opts';

@Pipe({ name: 'captureStatusReason' })
export class CaptureStatusReasonPipe implements PipeTransform {
  transform = displayCaptureStatusReason;
}
